import { render } from "./WellnessLineChart.vue?vue&type=template&id=3e4c96de"
import script from "./WellnessLineChart.vue?vue&type=script&lang=js"
export * from "./WellnessLineChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__